import CryptoJS from 'crypto-js'
export default {
    /**
     * @param {*需要加密的字符串 注：对象转化为json字符串再加密} word
     * @param {*aes加密需要的key值，这个key值后端同学会告诉你} keyStr
     * 两个方法中的第一个参数word是待加密或者解密的字符串，第二个参数keyStr是aes加密需要用到的16位字符串的key。如果想对一个js对象加密，需要先把该对象转成json字符串。
     */
    encrypt(word, keyStr) { // 对称加密
        var key = CryptoJS.enc.Utf8.parse(keyStr)
        var srcs = CryptoJS.enc.Utf8.parse(JSON.stringify(word))
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }) // 加密模式为ECB，补码方式为PKCS5Padding（也就是PKCS7）
        return encrypted.toString()
    },
    // 非对称加密
    encryptRsa(key) {
        let encryptor = new JSEncrypt() // 新建JSEncrypt对象
        let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC6m8p/XgR+fN1RrhehITYNy2lKpIjwb5qtNPSUzY3/Jv5N9cNw+9ESGAmL5z/ZH7KpYeyqgQ9Sa4koQuk4020n+DATJMXznkw01iZARcBuh8tyzlCwKjMZz9ZOX3zko0uJo6BL7LRCB/m9e3INFXnakGz/9EHgNAfmDo3BMxN+ywIDAQAB' // 把之前生成的贴进来，实际开发过程中，可以是后台传过来的
        encryptor.setPublicKey(publicKey) // 设置公钥
        let rsaPassWord = encryptor.encrypt(key) // 对需要加密的数据进行加密
        return rsaPassWord // 得到加密后的数据
    },
    // 对称解密
    decrypt(word, keyStr) {
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var decrypt = CryptoJS.AES.decrypt(word, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return JSON.parse(decrypt.toString(CryptoJS.enc.Utf8));
    },
    // 非对称解密方法
    RSAdecrypt(pas) {
        var privateKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAKjVb15pPBymYMFmJ67j0qkFU/uRxv6ohpXy/09BaMII46oLWoeCMPQtvTNz7jNgHtJ/TTisbBMTKCTrTBfJM1bmrW1sp0fgLouPWQPTB8G4hZwRuenLQEQQToPU6hLRd+17I6fDdqpiQaeEBnB1hmX4ppKjpcdpBXdoQfGSNIZlAgMBAAECgYBM7TsaVG68Sx7I4CfyqwGgW7ohZRG7lMQF7LthvFbkGjLJlvS/y5VMnM6ZdBgztnc0yCZCTWXM5yyibce1Csrl7qZ7r7/uX/iRiDA+rz+TUbcWapcyDswiKja9Z1dqebriSPjmwwduV+DU2YOcZLyqHo9S5tAbj4Q2EOVGlt+3fQJBAOAY8n5rG/41yH8qSRoztO1tGRteHD16UkKkDg+0IjrH+JcPCW6n8p734B+Aq8JXAE3yAxnhw9n+kzf39em855sCQQDA3nIUypYANZnCpCNyOht5+4rGcEUUU1/jEtcbrhnvalWulUSdZwg344n46w0dEgkgmSGsW53Z5+ulcgg99in/AkBpqNmM6YuFTG6AJrvY8tA3sdzInpLKGcZ3TUqj9Na+yFJZRum3ltA6S70MnWpecw7dsWHs7hmdyv42wV7dGghJAkEAnP61uEzr60G2ZuU7YUkBgrsKTNuor5HqlKmKZiLDQ8q38kPZNZNf8jaK4g9bflVnDpz39xgglvcdL3ByWxWdOwJAKEhNFPlUdatIA6bJ5x+DgMHzDuqFxEa22WiHVC8djLpQAXMOCYOvE99+kOm3upikU9KWXIEUjm6mAL9zkMwS9A=='
        let jse = new JSEncrypt();
        // 私钥
        jse.setPrivateKey(privateKey)
        return jse.decrypt(pas);
    },
    // 生成随机数
    RandomNumber(pasLen) {
        var pasArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        var password = '';
        var pasArrLen = pasArr.length;
        for (var i = 0; i < pasLen; i++) {
            var x = Math.floor(Math.random() * pasArrLen);
            password += pasArr[x];
        }
        return password;
    },
    // 访问接口前对数据加密的公用方法
    /* userParam  字符串拼接 */
    PublicEntryption(userParam) {
        // token token值
        // Page 当前页
        // PageSize 每页默认10条
        // UserType type为1时 参会企业  需要传此参数  传1采购商 2供货商
        let ariginalKey = this.RandomNumber(16); // 生成随机得key值
        let EntryptionUserParam = this.encrypt(userParam, ariginalKey); // 用随机生成的key值对称机密用户信息
        let encryptRsakey = this.encryptRsa(ariginalKey); // 对随机生成的key值进行非对称加密
        let reslutModel = {
            encryptData: EntryptionUserParam,
            key: encryptRsakey
        };
        return encodeURIComponent(JSON.stringify(reslutModel))
    },
    // 解密
    PublicDecode(response) {
        let keyParam = response.key; // 对解密要用到得key值进行解码
        let dataParam = response.encryptData; // 对返回来的数据进行解码
        let key = this.RSAdecrypt(keyParam); // 非对称解密 key值
        let data = this.decrypt(dataParam, key); // 用得到的key值对返回来数据进行对称解密
        return data
    },
    /**
 * 保留年月日，去除时分秒（返回格式化字符串）
 * @param {Date} date - 原始Date对象
 * @returns {string} 格式：YYYY-MM-DD
 */
    formatDateToYMD(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        throw new Error('参数必须是有效的Date对象');
    }
    const year = date.getFullYear();
    // 月份从0开始，需+1，不足两位补0
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
    }
}


// WEBPACK FOOTER //
// ./src/assets/until.js